import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { ApiMethod } from '../decorators/api-method.decorator';
import { Observable } from 'rxjs';
import { Item } from '../models/item.model';
import { AssetItemDetails } from '../models/asset-item-details.model';

@Injectable({
	providedIn: 'root'
})
export class SiteService {

	private readonly baseUrl = `${environment.baseUrl}/site`;

	constructor(
		private http: HttpClient,
		private authService: AuthService
	) { }

	@ApiMethod()
	public getSiteAssets(accountSiteId: number): Observable<Item<number, string>[]> {
		return this.http.get<Item<number, string>[]>(`${this.baseUrl}/${accountSiteId}/assets`, { headers: this.authService.getAuthenticationHeader() });
	}

	@ApiMethod()
	public getAssetDetails(assetId: number): Observable<AssetItemDetails> {
		return this.http.get<AssetItemDetails>(`${this.baseUrl}/${assetId}/asset-details`);
	}

	@ApiMethod()
	public getAssetSubTypes(resourceTypeId: number): Observable<Item<number, string>[]> {
		return this.http.get<Item<number, string>[]>(`${this.baseUrl}/${resourceTypeId}/subTypes`);
	}
}
